<template>
    <div class="seller-badge-vendor-dropdown">
        <div class="column">
            <select v-model="filters.badge.id" name="badge_status" id="badge_name" class="vendor-picker">
                <option value="0">{{ __('Search by badge', 'dokan') }}</option>
                <option v-for="badge in badges" :key="badge.id" :value="badge.id">{{ badge.badge_name }}</option>
            </select>
            <button
                v-if="0 !== filters.badge.id"
                type="button"
                class="button"
                @click="clearBadgeFilter"
            >&times;
            </button>
        </div>
    </div>
</template>

<script>
import mixin from "../../Mixin.js";
export default {
    name: 'BadgeDropDown',
    mixins: [mixin],
    data () {
        return {
            badges: [],
            filters: {
                badge: {
                    id: 0,
                    badge_name: this.__('Search by badge', 'dokan'),
                },
            },
        }
    },
    methods: {
        clearBadgeFilter () {
            this.searchByBadge = false
            this.filters.badge.id = 0
            this.filters.badge.badge_name = this.__('Search by badge', 'dokan')
        },

        fetchBadges () {
            const self = this;
            const selected_badge_id = undefined !== self.$route.query.badge_id ? parseInt( self.$route.query.badge_id ) : 0;
            let args = {
                badge_status: 'all',
                per_page: -1,
            };

            dokan.api.get('/seller-badge/', args).done( (response) => {
                self.badges = response;

                const selected_badge = response.find( (item) => {
                    return selected_badge_id === parseInt( item.id );
                } );

                if ( undefined === selected_badge ) {
                    return;
                }

                self.filters.badge.badge_name = selected_badge.badge_name;
                self.filters.badge.id = selected_badge.id;
            }).fail( ( jqXHR ) => {
                self.badges = [];
                let message = dokan_handle_ajax_error( jqXHR );
                if ( message ) {
                    self.showErrorAlert( message );
                }
            } );
        },
    },
    watch: {
        'filters.badge.id' () {
            const badge_id = this.filters.badge.id;
            const selected_badge_id = undefined !== this.$route.query.badge_id ? parseInt( this.$route.query.badge_id ) : 0;
            if ( 0 !== badge_id && badge_id !== selected_badge_id ) {
                this.$router.push({
                    name: 'Vendors',
                    query: {
                        badge_id: badge_id,
                    },
                });
            } else if( 0 === badge_id ) {
                this.$router.push({
                    name: 'Vendors',
                });
            }

            this.$emit('updateVendorComponent', true)
        },
    },
    created () {
        this.fetchBadges()
    },
}
</script>

<style lang="less" scoped>
.seller-badge-vendor-dropdown {
    display: inline-block;
    margin-right: 6px;

    .column {
        display: flex;
    }
}
</style>
